import { GetLessonFolderResponse } from '@/hooks/useLessonFolder/gql';
import { useMedia } from '@/hooks/useMedia/useMedia';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import Button from '@mui/material/Button';
import { PageHeader, PageHeaderToolbar } from '@toolpad/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

type PageHeaderToolbarProps = {
    tab?: number;
    disableButtons?: boolean;
    breadcrumbs?: { title: string; path: string }[];
    defaultTitle?: string;
    currentFolder?: GetLessonFolderResponse['lessonFolder'];
    onCreateFolder?: () => void;
    onCreateLesson?: () => void;
};

export function LessonPageToolbar(props: PageHeaderToolbarProps) {
    const { t } = useTranslation();
    const { isMobile } = useMedia();

    return (
        <PageHeaderToolbar>
            {!props.disableButtons && !props.currentFolder?.id && (
                <Button variant='outlined' startIcon={isMobile ? undefined : <CreateNewFolderIcon />} onClick={props.onCreateFolder}>
                    {isMobile ? <CreateNewFolderIcon /> : t('lesson.new.folder')}
                </Button>
            )}
            {!props.disableButtons && (
                <Button variant='contained' startIcon={isMobile ? undefined : <AddPhotoAlternateIcon />} onClick={props.onCreateLesson}>
                    {isMobile ? <AddPhotoAlternateIcon /> : t('lesson.new.lesson')}
                </Button>
            )}
        </PageHeaderToolbar>
    );
}

export function LessonPageHeader(props: PageHeaderToolbarProps) {
    const LessonPageToolbarComponent = React.useCallback(() => <LessonPageToolbar {...props} />, [props]);
    const title = props.currentFolder?.name ?? props.defaultTitle;
    const breadcrumbs = [{ title: props.defaultTitle ?? '', path: `/lessons` }, ...(props.breadcrumbs ?? [])];

    return <PageHeader slots={{ toolbar: LessonPageToolbarComponent }} title={title} breadcrumbs={breadcrumbs} />;
}
